// extracted by mini-css-extract-plugin
export default {"title":"ContactInfoClientForm_title__NUAB6","buttonIcon":"ContactInfoClientForm_buttonIcon__lBuXP","iconDelete":"ContactInfoClientForm_iconDelete__SmcS8"};